export default __webpack_public_path__ + "static/media/img_6.b96472c4.jpg";